// File: src/index.tsx

import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import {BrowserRouter} from 'react-router-dom';
import {GoogleOAuthProvider} from '@react-oauth/google';
import {QueryClient, QueryClientProvider} from '@tanstack/react-query';
import {ThemeProvider} from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';
import theme from './theme/theme';
import {UserProvider} from './context/UserContext';
import App from './App';
import './index.css';
import './styles/pdf-export.css';
import './i18n';


const queryClient = new QueryClient();
const googleClientId = process.env.REACT_APP_GOOGLE_CLIENT_ID;

if (!googleClientId) {
    throw new Error("Missing REACT_APP_GOOGLE_CLIENT_ID environment variable.");
}

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        {/* --- Providers that don't depend on others can be higher up --- */}
        <QueryClientProvider client={queryClient}>
            <GoogleOAuthProvider clientId={googleClientId}>
                {/* --- ThemeProvider should wrap everything that uses MUI components --- */}
                <ThemeProvider theme={theme}>
                    {/* 2. CssBaseline resets browser styles and applies theme defaults */}
                    <CssBaseline/>
                    <BrowserRouter>
                        {/* UserProvider often needs router context, so it's good practice to have it inside */}
                        <UserProvider>
                            <Suspense fallback={<div>Loading translations...</div>}> {/* ← обернуть App в Suspense */}
                                <App />
                            </Suspense>
                        </UserProvider>
                    </BrowserRouter>
                </ThemeProvider>
            </GoogleOAuthProvider>
        </QueryClientProvider>
    </React.StrictMode>
);
